import { faker } from '@faker-js/faker'

import { ConsultationState, ProcessStatus, UserConsultation } from '../../contracts/consultation'
import { asBuilder } from '../asBuilder'

export const createUserConsultation = asBuilder((): UserConsultation => {
  return {
    id: faker.number.int(),
    type: faker.helpers.arrayElement(['RESERVATION', 'CONSULTATION']),
    createdAt: faker.date.recent().toString(),
    operationType: faker.helpers.arrayElement(['SURGICAL', 'NONSURGICAL', 'UNKNOWN']),
    processStatus: faker.helpers.enumValue(ProcessStatus),
    consState: faker.helpers.enumValue(ConsultationState),
    isChat: faker.datatype.boolean(),
    chatRoomId: faker.string.uuid(),
    offlinePointRedeemAmount: faker.number.int(),
    offlinePointCurrency: faker.helpers.arrayElement(['KRW', 'JPY']),
    memberId: faker.number.int(),
    hospitalId: faker.number.int(),
    purchaseId: faker.helpers.arrayElement([faker.number.int(), null]),
    requestedReservedAt: faker.helpers.arrayElement([faker.date.future().toString(), null]),
    requestedReservedAtList: faker.helpers.arrayElement([Array(3).fill(faker.date.future().toString()), null]),
    confirmedReservedAt: faker.helpers.arrayElement([faker.date.future().toString(), null]),
    originType: faker.helpers.arrayElement(['EVENT', 'TENDER', 'DOCTOR']),
    originId: faker.number.int(),
    originTitle: faker.string.sample(),
    originImage: faker.image.url(),
    specialOfferPrice: faker.helpers.arrayElement([faker.number.int(), null]),
    memberName: faker.string.sample(5),
    memberPhoneNumber: faker.helpers.arrayElement([faker.phone.number(), null]),
    memberEmail: faker.helpers.arrayElement([faker.internet.email(), null]),
    memberCountry: faker.string.alpha(2),
    isReviewed: faker.datatype.boolean(),
    orderId: faker.string.uuid(),
  }
})
